import { Video, ScanFace, ListChecks, HeartPulse } from "lucide-react";

// Single source of truth for the 4 meeting types — drives the type selector
// in MeetingForm, the type tabs + badges in Meetings.jsx, and the badge in
// MeetingDetail.jsx. Icons match the ones already established for these
// same concepts in SessionRoom/sessionTypes.js, kept visually consistent
// across the app. This is a label only — no linked recruitment interview,
// verification engine, or patient record; see backend Meeting.meeting_type
// docstring for the full rationale.
export const MEETING_TYPES = [
  { key: "meeting",    label: "Meeting",    icon: Video,      color: "cyan" },
  { key: "ekyc",       label: "eKYC",       icon: ScanFace,   color: "purple" },
  { key: "interview",  label: "Interview",  icon: ListChecks, color: "green" },
  { key: "healthcare", label: "Healthcare", icon: HeartPulse, color: "red" },
];

export const getMeetingType = (key) => MEETING_TYPES.find((t) => t.key === key) || MEETING_TYPES[0];

// Per-type framing for the AI Summary card subtitle on MeetingDetail — the
// backend tunes the actual prompt (see openai_service._SUMMARY_ANGLE); this
// is just the matching UI copy.
export const SUMMARY_SUBTITLE = {
  meeting: "What was discussed and decided, generated automatically once the call ended.",
  interview: "Candidate evaluation recap — answers, communication, and hire-worthy signals — generated automatically once the call ended.",
  healthcare: "Clinical notes — presenting complaint, discussion, and care plan — generated automatically once the call ended.",
  ekyc: "Verification outcome recap, generated automatically once the call ended.",
};
